import { Flex } from "@acko-tech/building-blocks.ui.common";
import { useOnload } from "@utils/useOnLoad";
import styled from "styled-components";
import { resolvePath } from "@utils/resolvePath";
import Hyperlink from "@components/common/hyperlink";
import Image from "next/image";
import DOMPurify from "isomorphic-dompurify";

const Container = styled(Flex)`
  justify-content: flex-start;
  align-items: center;
  padding: 12px;
  color: #4a4a4a;
  background: #efe9fb;
  padding-top: 28px;
  border-radius: 12px;
`;

const IconContainer = styled.div`
  width: 25px;
  height: 19px;
  padding-right: 10px;
  position: relative;
  margin-left: -5px;
`;

const DateContainer = styled.div`
  color: "#4a4a4a";
  font-size: 12px;
  span {
    font-weight: 500
  }
`;

const PolicyStartDate = ({ children, ...props }) => {
  const {
    text,
    date,
    isPiRequired,
    piText,
    imgSrc,
    isResolvePath = false,
    imgStyles,
    isModalRequired = true,
    styles,
    wrapperStyles,
    expiredText,
    expiredTextStyles,
    is_visible,
    actions
  } = props || {};

  const { on_click } = actions || {};
  if(!is_visible) return null;
  return date || isPiRequired ? (
    <Flex style={wrapperStyles}>
      <Container style={styles}>
        <IconContainer style={imgStyles}>
          <Image
            src={isResolvePath ? resolvePath(imgSrc) : imgSrc}
            alt="calendar-icon"
            layout="fill"
            objectFit="contain"
            style={imgStyles}
          />
        </IconContainer>
        {isPiRequired ? (
          <Flex alignItems="center">
            <DateContainer
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(piText)
              }}
            />
           
            {isModalRequired && (
              <Hyperlink
                clickHandler={() => {
                  if (on_click?.length > 0) {
                    on_click?.forEach((eachFunc: any) => {
                      if (typeof eachFunc.funCall === "function") {
                        eachFunc.funCall(eachFunc.args);
                      }
                    });
                  }
                }}
                is_visible={true}
                text="Know more"
                type="UNDERLINE"
                styles={{
                  display: "inline-block",
                  width: "max-content",
                  color: "#36354C",
                  fontWeight: "500",
                  marginLeft: "3px"
                }}
              />
            )}
          </Flex>
        ) : (
            <DateContainer>
              {text}
              <strong
                style={{
                  marginLeft: "4px",
                  color: "#040222",
                  fontWeight: "500"
                }}
              >
                {date}
              </strong>
            </DateContainer>
        )}
      </Container>
    </Flex>
  ) : (
    <Flex style={wrapperStyles}>
      <Container style={styles}>
        {imgSrc && (
          <IconContainer style={imgStyles}>
            <Image
              src={isResolvePath ? resolvePath(imgSrc) : imgSrc}
              alt="calendar-icon"
              layout="fill"
              objectFit="contain"
              style={imgStyles}
            />
          </IconContainer>
        )}
        <DateContainer
          style={expiredTextStyles}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(expiredText)
          }}
        />
      </Container>
    </Flex>
  );
};

export default PolicyStartDate;
